import React, { useContext, useEffect, useState } from "react";
import { getDriversRisks, getSingleStockData } from "../data-tables/data/getData";
import InfoIcon from "@mui/icons-material/Info";
import { style } from "@mui/system";
import { roundToTwo } from "layouts/Helper/helper";
import KeyIconOrData from "components/etc/KeyIconOrData";
import { TLSText } from "components/CustomComponents";
import { TLSColour } from "components/CustomComponents";
import { TLSGEMColour } from "components/CustomComponents";
import { StockInfoPopup } from "components/CustomPopups/StockPopups";
import SoftTypography from "components/SoftTypography";
import { CircularProgress, Grid } from "@mui/material";
import SoftBox from "components/SoftBox";

import useAuth from "layouts/authentication/hooks/useAuth";

function StockDetailsTable({ code, current, fullData }) {
  const [theStockData, setStockData] = useState(0);
  const [infoPopup, toggleInfoPopup] = useState(false);
  const [popupAccessor, setPopupAccessor] = useState("");

  const { auth } = useAuth();

  const handleInfoPop = (popupAccessor) => {
    console.log("pressed");
    toggleInfoPopup(true);
    setPopupAccessor(popupAccessor);
  };

  useEffect(() => {
    setStockData(fullData);
  }, [fullData]);

  const GemRanking = () => {
    return (
      <div>
        <div className="detailHeading bbvGrey">
          <h3>GEM Screener</h3>
        </div>
        <Grid container>
          <Grid item xs={12} md={6} p={2}>
            <div className="stockRow flex">
              <div className="inline " style={{ paddingLeft: "18px", paddingRight: "18px" }}>
                <div className="inline  infoIcon">
                  <InfoIcon
                    onClick={() => {
                      handleInfoPop("gemMarket");
                    }}
                    className="icon"
                  />
                </div>
                <p className="inline helvetica" style={{ fontSize: "14px" }}>
                  GEM Current Quarter
                </p>
              </div>
              <p
                className={current === "Company Description" ? "stockDesc" : "inline helvetica"}
                style={{ fontSize: "14px" }}
              >
                {!theStockData["GEM_Rank"] || theStockData["GEM_Rank"] <= 0 ? (
                  "-"
                ) : (
                  <KeyIconOrData
                    value={
                      !theStockData["GEM_Rank"] || theStockData["GEM_Rank"] > 5000 ? ">5000" : theStockData["GEM_Rank"]
                    }
                    requiredFeature="gem_ranking"
                    colour={TLSGEMColour(theStockData["GEM_Rank"], 1500, 2500)}
                  />
                )}
              </p>
              {/* <p className={current === "Company Description"?'stockDesc':"inline helvetica"} style={{fontSize:"14px"}}>{theStockData["GEM_Rank"]}</p>  */}
            </div>
            <div className="stockRow flex">
              <div className="inline " style={{ paddingLeft: "18px", paddingRight: "18px" }}>
                <div className="inline  infoIcon">
                  <InfoIcon
                    onClick={() => {
                      handleInfoPop("gemPrevious");
                    }}
                    className="icon"
                  />
                </div>
                <p className="inline helvetica" style={{ fontSize: "14px" }}>
                  GEM Previous Quarter
                </p>
              </div>
              <p
                className={current === "Company Description" ? "stockDesc" : "inline helvetica"}
                style={{ fontSize: "14px" }}
              >
                <KeyIconOrData
                  value={theStockData["GEM_Rank_one"]}
                  requiredFeature="gem_ranking"
                  colour={TLSGEMColour(theStockData["GEM_Rank_one"], 1500, 2500)}
                />
              </p>
              {/* <p className={current === "Company Description"?'stockDesc':"inline helvetica"} style={{fontSize:"14px"}}>{theStockData["GEM_Rank_one"]}</p>  */}
            </div>
            <div className="stockRow flex">
              <div className="inline " style={{ paddingLeft: "18px", paddingRight: "18px" }}>
                <div className="inline  infoIcon">
                  <InfoIcon
                    onClick={() => {
                      handleInfoPop("gemTwoQuarters");
                    }}
                    className="icon"
                  />
                </div>
                <p className="inline helvetica" style={{ fontSize: "14px" }}>
                  GEM Two Quarters ago
                </p>
              </div>
              <p
                className={current === "Company Description" ? "stockDesc" : "inline helvetica"}
                style={{ fontSize: "14px" }}
              >
                <KeyIconOrData
                  value={theStockData["GEM_Rank_two"]}
                  requiredFeature="gem_ranking"
                  colour={TLSGEMColour(theStockData["GEM_Rank_two"], 1500, 2500)}
                />
              </p>
              {/* <p className={current === "Company Description"?'stockDesc':"inline helvetica"} style={{fontSize:"14px"}}>{theStockData["GEM_Rank_two"]}</p>  */}
            </div>
            <div className="stockRow flex">
              <div className="inline " style={{ paddingLeft: "18px", paddingRight: "18px" }}>
                <div className="inline  infoIcon">
                  <InfoIcon
                    onClick={() => {
                      handleInfoPop("gemThreeQuarters");
                    }}
                    className="icon"
                  />
                </div>
                <p className="inline helvetica" style={{ fontSize: "14px" }}>
                  GEM Three Quarters ago
                </p>
              </div>
              {/* <p className={current === "Company Description"?'stockDesc':"inline helvetica"} style={{fontSize:"14px"}}>{theStockData["GEM_Rank_three"]}</p>  */}
              <p
                className={current === "Company Description" ? "stockDesc" : "inline helvetica"}
                style={{ fontSize: "14px" }}
              >
                <KeyIconOrData
                  value={theStockData["GEM_Rank_three"]}
                  requiredFeature="gem_ranking"
                  colour={TLSGEMColour(theStockData["GEM_Rank_three"], 1500, 2500)}
                />
              </p>
            </div>
          </Grid>
          <Grid item xs={12} md={6} p={2}>
            <div className="stockRow flex">
              <div className="inline " style={{ paddingLeft: "18px", paddingRight: "18px" }}>
                <div className="inline  infoIcon">
                  <InfoIcon
                    onClick={() => {
                      handleInfoPop("greatReturns");
                    }}
                    className="icon"
                  />
                </div>
                <p className="inline helvetica" style={{ fontSize: "14px" }}>
                  Great Return
                </p>
              </div>
              <TLSText
                higherBetter={true}
                value={roundToTwo(theStockData["ROIC"] * 100)}
                green={roundToTwo(theStockData["ROIC"] * 100) >= 30}
                yellow={roundToTwo(theStockData["ROIC"] * 100) > 0 && roundToTwo(theStockData["ROIC"] * 100) < 30}
                red={roundToTwo(theStockData["ROIC"] * 100) <= 0}
              />
            </div>
            <div className="stockRow flex">
              <div className="inline " style={{ paddingLeft: "18px", paddingRight: "18px" }}>
                <div className="inline  infoIcon">
                  <InfoIcon
                    onClick={() => {
                      handleInfoPop("cashflow");
                    }}
                    className="icon"
                  />
                </div>
                <p className="inline helvetica" style={{ fontSize: "14px" }}>
                  Efficient Cashflow
                </p>
              </div>
              <TLSText
                higherBetter={true}
                value={theStockData["Earnings_Quality"] ? roundToTwo(theStockData["Earnings_Quality"]) : "-"}
                green={theStockData["Earnings_Quality"] >= 30}
                yellow={
                  theStockData["Earnings_Quality"] >= 0 && roundToTwo(theStockData["Earnings_Quality"] * 100) < 30
                }
                red={theStockData["Earnings_Quality"] < 0}
              />
            </div>
            <div className="stockRow flex">
              <div className="inline " style={{ paddingLeft: "18px", paddingRight: "18px" }}>
                <div className="inline  infoIcon">
                  <InfoIcon
                    onClick={() => {
                      handleInfoPop("moneyvalue");
                    }}
                    className="icon"
                  />
                </div>
                <p className="inline helvetica" style={{ fontSize: "14px" }}>
                  Money Value
                </p>
              </div>
              <TLSText
                higherBetter={true}
                value={roundToTwo((theStockData["ebit"] / theStockData["ev"]) * 100)}
                green={roundToTwo((theStockData["ebit"] / theStockData["ev"]) * 100) >= 10}
                red={roundToTwo((theStockData["ebit"] / theStockData["ev"]) * 100) < 10}
              />
            </div>
          </Grid>
        </Grid>
      </div>
    );
  };
  const CompanyDescription = () => {
    return (
      <div>
        <div className="detailHeading bbvGrey">
          <h3>Company Description</h3>
        </div>
        <SoftBox p={2}>
          <SoftTypography variant="body2">{theStockData["description"]}</SoftTypography>
        </SoftBox>
      </div>
    );
  };

  const GeneralInformation = () => {
    return (
      <div>
        <div className="detailHeading bbvGrey">
          <h3>General Information</h3>
        </div>

        <Grid container>
          <Grid item xs={12} md={6} p={2}>
            <div className="stockRow flex">
              <div className="inline " style={{ paddingLeft: "18px", paddingRight: "18px" }}>
                <div className="inline  infoIcon">
                  <InfoIcon
                    onClick={() => {
                      handleInfoPop("currency");
                    }}
                    className="icon"
                  />
                </div>
                <p className="inline helvetica" style={{ fontSize: "14px" }}>
                  Currency
                </p>
              </div>
              <p className="inline helvetica" style={{ fontSize: "14px" }}>
                {theStockData["currency"] ?? "USD"}
              </p>
            </div>

            <div className="stockRow flex">
              <div className="inline " style={{ paddingLeft: "18px", paddingRight: "18px" }}>
                <div className="inline  infoIcon">
                  <InfoIcon
                    onClick={() => {
                      handleInfoPop("country");
                    }}
                    className="icon"
                  />
                </div>
                <p className="inline helvetica" style={{ fontSize: "14px" }}>
                  Country
                </p>
              </div>
              <p className="inline helvetica" style={{ fontSize: "14px" }}>
                {theStockData["CountryName"]}
              </p>
            </div>

            <div className="stockRow flex">
              <div className="inline " style={{ paddingLeft: "18px", paddingRight: "18px" }}>
                <div className="inline  infoIcon">
                  <InfoIcon
                    onClick={() => {
                      handleInfoPop("exchange");
                    }}
                    className="icon"
                  />
                </div>
                <p className="inline helvetica" style={{ fontSize: "14px" }}>
                  Exchange
                </p>
              </div>
              <p className="inline helvetica" style={{ fontSize: "14px" }}>
                {theStockData["exchange"]}
              </p>
            </div>

            <div className="stockRow flex">
              <div className="inline " style={{ paddingLeft: "18px", paddingRight: "18px" }}>
                <div className="inline  infoIcon">
                  <InfoIcon
                    onClick={() => {
                      handleInfoPop("sector");
                    }}
                    className="icon"
                  />
                </div>
                <p className="inline helvetica" style={{ fontSize: "14px" }}>
                  Sector
                </p>
              </div>
              <p className="inline helvetica" style={{ fontSize: "14px" }}>
                {theStockData["Sector"]}
              </p>
            </div>
          </Grid>
          <Grid item xs={12} md={6} p={2}>
            <div className="stockRow flex">
              <div className="inline " style={{ paddingLeft: "18px", paddingRight: "18px" }}>
                <div className="inline  infoIcon">
                  <InfoIcon
                    onClick={() => {
                      handleInfoPop("industry");
                    }}
                    className="icon"
                  />
                </div>
                <p className="inline helvetica" style={{ fontSize: "14px" }}>
                  Industry
                </p>
              </div>
              <p className="inline helvetica" style={{ fontSize: "14px" }}>
                {theStockData["industry"]}
              </p>
            </div>

            <div className="stockRow flex">
              <div className="inline " style={{ paddingLeft: "18px", paddingRight: "18px" }}>
                <div className="inline  infoIcon">
                  <InfoIcon
                    onClick={() => {
                      handleInfoPop("marketCap");
                    }}
                    className="icon"
                  />
                </div>
                <p className="inline helvetica" style={{ fontSize: "14px" }}>
                  Market Cap (Million)
                </p>
              </div>
              <TLSText
                higherBetter={true}
                value={roundToTwo(theStockData["MarketCapitalizationMln"])}
                green={roundToTwo(theStockData["MarketCapitalizationMln"]) >= 10000}
                yellow={
                  roundToTwo(theStockData["MarketCapitalizationMln"]) >= 2000 &&
                  roundToTwo(theStockData["MarketCapitalizationMln"]) < 10000
                }
                red={roundToTwo(theStockData["MarketCapitalizationMln"]) < 2000}
              />
            </div>

            <div className="stockRow flex">
              <div className="inline " style={{ paddingLeft: "18px", paddingRight: "18px" }}>
                <div className="inline  infoIcon">
                  <InfoIcon
                    onClick={() => {
                      handleInfoPop("divYield");
                    }}
                    className="icon"
                  />
                </div>
                <p className="inline helvetica" style={{ fontSize: "14px" }}>
                  Annual Dividend Yield
                </p>
              </div>
              <TLSText
                higherBetter={true}
                value={theStockData["currentDividendYieldTTM"]}
                green={theStockData["currentDividendYieldTTM"] >= 7}
                yellow={
                  theStockData["currentDividendYieldTTM"] >= 4 &&
                  roundToTwo(theStockData["currentDividendYieldTTM"] * 100) < 7
                }
                red={theStockData["currentDividendYieldTTM"] < 4}
              />
            </div>

            <div className="stockRow flex">
              <div className="inline " style={{ paddingLeft: "18px", paddingRight: "18px" }}>
                <div className="inline  infoIcon">
                  <InfoIcon
                    onClick={() => {
                      handleInfoPop("recentQuarter");
                    }}
                    className="icon"
                  />
                </div>
                <p className="inline helvetica" style={{ fontSize: "14px" }}>
                  Most Recent Quarter
                </p>
              </div>
              <p className="inline helvetica" style={{ fontSize: "14px" }}>
                {theStockData["mostRecentQuarter"]}
              </p>
            </div>
          </Grid>
        </Grid>
      </div>
    );
  };

  const KeyFinancialRatios = () => {
    return (
      <div>
        <div className="detailHeading bbvGrey">
          <h3>Key Financial Ratios</h3>
        </div>

        <Grid container>
          <Grid item xs={12} md={6} p={2}>
            <div className="stockRow flex">
              <div className="inline " style={{ paddingLeft: "18px", paddingRight: "18px" }}>
                <div className="inline  infoIcon">
                  <InfoIcon
                    onClick={() => {
                      handleInfoPop("PERatio");
                    }}
                    className="icon"
                  />
                </div>
                <p className="inline helvetica" style={{ fontSize: "14px" }}>
                  Price to Equity (PE) Ratio
                </p>
              </div>
              <TLSText
                higherBetter={false}
                value={roundToTwo(theStockData["peTTM"])}
                green={roundToTwo(theStockData["peTTM"]) <= 15}
                yellow={
                  roundToTwo(theStockData["peTTM"]) <= roundToTwo(theStockData["sector_peTTM_a"]) &&
                  roundToTwo(theStockData["peTTM"]) > 15
                }
                red={roundToTwo(theStockData["peTTM"]) > roundToTwo(theStockData["sector_peTTM_a"])}
              />
            </div>

            <div className="stockRow flex">
              <div className="inline " style={{ paddingLeft: "18px", paddingRight: "18px" }}>
                <div className="inline  infoIcon">
                  <InfoIcon
                    onClick={() => {
                      handleInfoPop("PBRatio");
                    }}
                    className="icon"
                  />
                </div>
                <p className="inline helvetica" style={{ fontSize: "14px" }}>
                  Price to Book Ratio
                </p>
              </div>
              <TLSText
                higherBetter={false}
                value={roundToTwo(theStockData["pb"])}
                green={roundToTwo(theStockData["pb"]) == 1}
                yellow={roundToTwo(theStockData["pb"]) < 1}
                red={roundToTwo(theStockData["pb"]) > 1}
              />
            </div>

            <div className="stockRow flex">
              <div className="inline " style={{ paddingLeft: "18px", paddingRight: "18px" }}>
                <div className="inline  infoIcon">
                  <InfoIcon
                    onClick={() => {
                      handleInfoPop("PEGRatio");
                    }}
                    className="icon"
                  />
                </div>
                <p className="inline helvetica" style={{ fontSize: "14px" }}>
                  PE Growth Ratio
                </p>
              </div>
              <TLSText higherBetter={false} value={roundToTwo(theStockData["PEG_Ratio"])} green={1} red={1} />
            </div>

            <div className="stockRow flex">
              <div className="inline " style={{ paddingLeft: "18px", paddingRight: "18px" }}>
                <div className="inline  infoIcon">
                  <InfoIcon
                    onClick={() => {
                      handleInfoPop("SPERatio");
                    }}
                    className="icon"
                  />
                </div>
                <p className="inline helvetica" style={{ fontSize: "14px" }}>
                  Sector PE Ratio
                </p>
              </div>
              <p className="inline helvetica" style={{ fontSize: "14px" }}>
                {roundToTwo(theStockData["sector_peTTM_a"])}
              </p>
            </div>
          </Grid>
          <Grid item xs={12} md={6} p={2}>
            <div className="stockRow flex">
              <div className="inline " style={{ paddingLeft: "18px", paddingRight: "18px" }}>
                <div className="inline  infoIcon">
                  <InfoIcon
                    onClick={() => {
                      handleInfoPop("ROE");
                    }}
                    className="icon"
                  />
                </div>
                <p className="inline helvetica" style={{ fontSize: "14px" }}>
                  Return on Equity
                </p>
              </div>
              <TLSText
                higherBetter={true}
                value={roundToTwo(theStockData["roeTTM"])}
                green={roundToTwo(theStockData["roeTTM"]) >= 20}
                yellow={roundToTwo(theStockData["roeTTM"]) >= 0 && roundToTwo(theStockData["roeTTM"]) < 20}
                red={roundToTwo(theStockData["roeTTM"]) < 0}
              />
            </div>

            <div className="stockRow flex">
              <div className="inline " style={{ paddingLeft: "18px", paddingRight: "18px" }}>
                <div className="inline  infoIcon">
                  <InfoIcon
                    onClick={() => {
                      handleInfoPop("ROA");
                    }}
                    className="icon"
                  />
                </div>
                <p className="inline helvetica" style={{ fontSize: "14px" }}>
                  Return on Asset
                </p>
              </div>
              <TLSText
                higherBetter={true}
                value={roundToTwo(theStockData["roaTTM"])}
                green={roundToTwo(theStockData["roaTTM"]) >= 10}
                yellow={roundToTwo(theStockData["roaTTM"]) >= 0 && roundToTwo(theStockData["roaTTM"]) < 10}
                red={roundToTwo(theStockData["roaTTM"]) < 0}
              />
            </div>
          </Grid>
        </Grid>

        <div className="detailHeading bbvGrey">
          <h3>General Earning Data</h3>
        </div>
        <Grid container>
          <Grid item xs={12} md={6} p={2}>
            <div className="stockRow flex">
              <div className="inline " style={{ paddingLeft: "18px", paddingRight: "18px" }}>
                <div className="inline  infoIcon">
                  <InfoIcon
                    onClick={() => {
                      handleInfoPop("EPS");
                    }}
                    className="icon"
                  />
                </div>
                <p className="inline helvetica" style={{ fontSize: "14px" }}>
                  Earnings Per Share
                </p>
              </div>
              <TLSText
                higherBetter={true}
                value={roundToTwo(theStockData["epsEstimateAvg"])}
                green={roundToTwo(theStockData["epsEstimateAvg"]) >= 0}
                red={roundToTwo(theStockData["epsEstimateAvg"]) < 0}
              />
            </div>
          </Grid>
        </Grid>
      </div>
    );
  };

  const IncomeStatement = () => {
    return (
      <div>
        <div className="detailHeading bbvGrey">
          <h3>Income Statement</h3>
        </div>

        <Grid container>
          <Grid item xs={12} md={6} p={2}>
            <div className="stockRow flex">
              <div className="inline " style={{ paddingLeft: "18px", paddingRight: "18px" }}>
                <div className="inline  infoIcon">
                  <InfoIcon
                    onClick={() => {
                      handleInfoPop("GPM");
                    }}
                    className="icon"
                  />
                </div>
                <p className="inline helvetica" style={{ fontSize: "14px" }}>
                  Gross Profit Margin %
                </p>
              </div>
              <TLSText
                higherBetter={true}
                value={roundToTwo(theStockData["GrossProfitMargin"])}
                green={roundToTwo(theStockData["GrossProfitMargin"]) >= 30}
                yellow={
                  roundToTwo(theStockData["GrossProfitMargin"]) >= 0 &&
                  roundToTwo(theStockData["GrossProfitMargin"]) < 30
                }
                red={roundToTwo(theStockData["GrossProfitMargin"]) < 0}
              />
            </div>

            <div className="stockRow flex">
              <div className="inline " style={{ paddingLeft: "18px", paddingRight: "18px" }}>
                <div className="inline  infoIcon">
                  <InfoIcon
                    onClick={() => {
                      handleInfoPop("OM");
                    }}
                    className="icon"
                  />
                </div>
                <p className="inline helvetica" style={{ fontSize: "14px" }}>
                  Operating Margin %
                </p>
              </div>
              <TLSText
                higherBetter={true}
                value={roundToTwo(theStockData["operatingMarginTTM"])}
                green={roundToTwo(theStockData["operatingMarginTTM"]) >= 20}
                yellow={
                  roundToTwo(theStockData["operatingMarginTTM"]) >= 0 &&
                  roundToTwo(theStockData["operatingMarginTTM"]) < 20
                }
                red={roundToTwo(theStockData["operatingMarginTTM"]) < 0}
              />
            </div>
          </Grid>
          <Grid item xs={12} md={6} p={2}>
            <div className="stockRow flex">
              <div className="inline " style={{ paddingLeft: "18px", paddingRight: "18px" }}>
                <div className="inline  infoIcon">
                  <InfoIcon
                    onClick={() => {
                      handleInfoPop("NPM");
                    }}
                    className="icon"
                  />
                </div>
                <p className="inline helvetica" style={{ fontSize: "14px" }}>
                  Net Profit Margin %
                </p>
              </div>
              <p className="inline helvetica" style={{ fontSize: "14px" }}>
                <TLSText
                  higherBetter={true}
                  value={roundToTwo(theStockData["netProfitMarginTTM"])}
                  green={roundToTwo(theStockData["netProfitMarginTTM"]) >= 20}
                  yellow={
                    roundToTwo(theStockData["netProfitMarginTTM"]) >= 0 &&
                    roundToTwo(theStockData["netProfitMarginTTM"]) < 20
                  }
                  red={roundToTwo(theStockData["netProfitMarginTTM"]) < 0}
                />
              </p>
            </div>

            <div className="stockRow flex">
              <div className="inline " style={{ paddingLeft: "18px", paddingRight: "18px" }}>
                <div className="inline  infoIcon">
                  <InfoIcon
                    onClick={() => {
                      handleInfoPop("NBAT");
                    }}
                    className="icon"
                  />
                </div>
                <p className="inline helvetica" style={{ fontSize: "14px" }}>
                  NPAT {"<"} EBIT ?
                </p>
              </div>
              {/* <p className="inline helvetica" style={{fontSize:"14px"}}>{(theStockData["NBAT_Is_Less_Than_Ebit"])}</p>  */}
              <p
                className={current === "Company Description" ? "stockDesc" : "inline helvetica"}
                style={{ fontSize: "14px" }}
              >
                <KeyIconOrData
                  value={theStockData["NBAT_Is_Less_Than_Ebit"]}
                  requiredFeature="gem_ranking"
                  colour={theStockData["NBAT_Is_Less_Than_Ebit"] === "yes" ? "green" : "red"}
                />
              </p>
            </div>
          </Grid>
        </Grid>
      </div>
    );
  };

  const FinancialHealth = () => {
    return (
      <div>
        <div className="detailHeading bbvGrey">
          <h3>Liquidity</h3>
        </div>

        <Grid container>
          <Grid item xs={12} md={6} p={2}>
            <div className="stockRow flex">
              <div className="inline " style={{ paddingLeft: "18px", paddingRight: "18px" }}>
                <div className="inline  infoIcon">
                  <InfoIcon
                    onClick={() => {
                      handleInfoPop("CurrentRatio");
                    }}
                    className="icon"
                  />
                </div>
                <p className="inline helvetica" style={{ fontSize: "14px" }}>
                  Current Ratio
                </p>
              </div>
              <TLSText
                higherBetter={true}
                value={roundToTwo(theStockData["currentRatio"])}
                green={roundToTwo(theStockData["currentRatio"]) >= 2}
                yellow={roundToTwo(theStockData["currentRatio"]) >= 0 && roundToTwo(theStockData["currentRatio"]) < 2}
                red={roundToTwo(theStockData["currentRatio"]) < 0}
              />
            </div>
          </Grid>
        </Grid>

        <div className="detailHeading bbvGrey">
          <h3>Solvency</h3>
        </div>
        <Grid container>
          <Grid item xs={12} md={6} p={2}>
            <div className="stockRow flex">
              <div className="inline " style={{ paddingLeft: "18px", paddingRight: "18px" }}>
                <div className="inline  infoIcon">
                  <InfoIcon
                    onClick={() => {
                      handleInfoPop("DebtToEquity");
                    }}
                    className="icon"
                  />
                </div>
                <p className="inline helvetica" style={{ fontSize: "14px" }}>
                  Debt / Equity
                </p>
              </div>
              <TLSText
                higherBetter={false}
                value={roundToTwo(theStockData["totalDebtToEquity"])}
                green={roundToTwo(theStockData["totalDebtToEquity"]) <= 0}
                yellow={
                  roundToTwo(theStockData["totalDebtToEquity"]) <= 1 &&
                  roundToTwo(theStockData["totalDebtToEquity"]) > 0
                }
                red={roundToTwo(theStockData["totalDebtToEquity"]) > 1}
              />
            </div>

            <div className="stockRow flex">
              <div className="inline " style={{ paddingLeft: "18px", paddingRight: "18px" }}>
                <div className="inline  infoIcon">
                  <InfoIcon
                    onClick={() => {
                      handleInfoPop("DebtToAsset");
                    }}
                    className="icon"
                  />
                </div>
                <p className="inline helvetica" style={{ fontSize: "14px" }}>
                  Debt / Asset
                </p>
              </div>
              <p className="inline helvetica" style={{ fontSize: "14px" }}>
                <TLSText
                  higherBetter={false}
                  value={roundToTwo(theStockData["totalDebtToTotalAsset"])}
                  green={roundToTwo(theStockData["totalDebtToTotalAsset"]) <= 0}
                  yellow={
                    roundToTwo(theStockData["totalDebtToTotalAsset"]) <= 1 &&
                    roundToTwo(theStockData["totalDebtToTotalAsset"]) > 0
                  }
                  red={roundToTwo(theStockData["totalDebtToTotalAsset"]) > 1}
                />
              </p>
            </div>
          </Grid>
          <Grid item xs={12} md={6} p={2}>
            <div className="stockRow flex">
              <div className="inline " style={{ paddingLeft: "18px", paddingRight: "18px" }}>
                <div className="inline  infoIcon">
                  <InfoIcon
                    onClick={() => {
                      handleInfoPop("NetToNTA");
                    }}
                    className="icon"
                  />
                </div>
                <p className="inline helvetica" style={{ fontSize: "14px" }}>
                  Net Debt to NTA
                </p>
              </div>
              {/* <p className="inline helvetica" style={{fontSize:"14px"}}>{roundToTwo(theStockData["Net_Debt_To_NTA"])}</p>  */}
              <p
                className={current === "Company Description" ? "stockDesc" : "inline helvetica"}
                style={{ fontSize: "14px" }}
              >
                <KeyIconOrData
                  value={theStockData["totalDebtToTotalAsset"]}
                  requiredFeature="gem_ranking"
                  colour={theStockData["totalDebtToTotalAsset"] > 1 ? "red" : "green"}
                />
              </p>
            </div>
          </Grid>
        </Grid>
      </div>
    );
  };

  const FocusRatio = () => {
    return (
      <div>
        <div className="detailHeading bbvGrey">
          <h3>Focus Ratio</h3>
        </div>
        <Grid container>
          <Grid item xs={12} md={6} p={2}>
            <div className="stockRow flex">
              <div className="inline " style={{ paddingLeft: "18px", paddingRight: "18px" }}>
                <div className="inline  infoIcon">
                  <InfoIcon
                    onClick={() => {
                      handleInfoPop("QualityIncome");
                    }}
                    className="icon"
                  />
                </div>
                <p className="inline helvetica" style={{ fontSize: "14px" }}>
                  Quality Income
                </p>
              </div>
              <TLSText
                higherBetter={true}
                value={roundToTwo(theStockData["Earnings_Quality_Percentile"])}
                green={roundToTwo(theStockData["Earnings_Quality_Percentile"]) >= 1}
                red={roundToTwo(theStockData["Earnings_Quality_Percentile"]) < 1}
              />
            </div>
          </Grid>
          <Grid item xs={12} md={6} p={2}>
            <div className="stockRow flex">
              <div className="inline " style={{ paddingLeft: "18px", paddingRight: "18px" }}>
                <div className="inline  infoIcon">
                  <InfoIcon
                    onClick={() => {
                      handleInfoPop("Orecta");
                    }}
                    className="icon"
                  />
                </div>
                <p className="inline helvetica" style={{ fontSize: "14px" }}>
                  ORecTa%
                </p>
              </div>
              {/* <p className="inline helvetica" style={{fontSize:"14px"}}>{roundToTwo(theStockData["Orecta_Percentage"])}</p>  */}
              <p
                className={current === "Company Description" ? "stockDesc" : "inline helvetica"}
                style={{ fontSize: "14px" }}
              >
                <KeyIconOrData
                  value={roundToTwo(theStockData["Orecta_Percentage"] * 100)}
                  requiredFeature="gem_ranking"
                  colour={TLSGEMColour(theStockData["Orecta_Percentage"] * 100, 30, 50)}
                />
              </p>
            </div>
          </Grid>
        </Grid>
      </div>
    );
  };

  const DriversRisks = () => {
    const [loading, setLoading] = useState(true);
    const [drivers, setDrivers] = useState([]);
    const [risks, setRisks] = useState([]);

    useEffect(() => {
      loadData();
    }, []);

    const loadData = async () => {
      const data = await getDriversRisks(code);
      if (data.drivers) setDrivers(data.drivers);
      if (data.risks) setRisks(data.risks);

      setLoading(false);
    };

    return (
      <div>
        <div className="detailHeading bbvGrey">
          <h3>Drivers & Risks</h3>
        </div>
        {loading ? (
          <SoftBox p={3} align="center">
            <CircularProgress />
          </SoftBox>
        ) : (
          <Grid container>
            <Grid item xs={12} md={6}>
              <SoftBox p={3}>
                <SoftTypography variant="h5">Drivers</SoftTypography>
                {drivers.length > 0 ? (
                  <ul className="drivers">
                    {drivers.map((item) => (
                      <li>
                        <SoftTypography variant="body2">{item}</SoftTypography>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <SoftTypography variant="body2">
                    We are processing more data for this Stock to acertain Drivers. Please check back again soon.
                  </SoftTypography>
                )}
              </SoftBox>
            </Grid>
            <Grid item xs={12} md={6}>
              <SoftBox p={3}>
                <SoftTypography variant="h5">Risks</SoftTypography>
                {risks.length > 0 ? (
                  <ul className="risks">
                    {risks.map((item) => (
                      <li>
                        <SoftTypography variant="body2">{item}</SoftTypography>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <SoftTypography variant="body2">
                    We are processing more data for this Stock to acertain Risks. Please check back again soon.
                  </SoftTypography>
                )}
              </SoftBox>
            </Grid>
          </Grid>
        )}
      </div>
    );
  };

  const stockItems = [
    {
      title: "GEM Screener",
      page: <GemRanking />,
    },
    {
      title: "Company Description",
      page: <CompanyDescription />,
      headings: ["Company Description"],
      name: ["General_Description"],
    },
    {
      title: "General Information",
      page: <GeneralInformation />,
      isHeading: ["yes", "no", "no", "no", "no", "no", "no", "no", "no"],
      headings: [
        "General Information",
        "Currency",
        "Country",
        "Exchange",
        "Sector",
        "Industry",
        "Market Cap",
        "Annual Dividend Yield",
        "Most Recent Quarter",
      ],
      name: [
        "",
        "Financials_Income_Statement_currency_symbol",
        "General_CountryName",
        "General_Exchange",
        "General_Sector",
        "General_Industry",
        "Highlights_MarketCapitalization",
        "Highlights_DividendYield",
        "Highlights_MostRecentQuarter",
      ],
    },
    {
      title: "Key Financial Ratios",
      page: <KeyFinancialRatios />,
      isHeading: ["yes", "no", "no", "no", "no", "no", "no", "yes", "no"],
      headings: [
        "Key Financial Ratios",
        "Price to Equity (PE) Ratio",
        "PE Growth Ratio",
        "Sector PE Ratio",
        "Return on Equity",
        "Return on Asset",
        "Price to Book Ratio",
        "General Earning Data",
        "Earnings Per Share",
      ],
      name: [
        "",
        "Highlights_PERatio",
        "Highlights_PEGRatio",
        "Total_Sector_Highlights_PE",
        "Highlights_ReturnOnEquityTTM",
        "Highlights_ReturnOnAssetsTTM",
        "Valuation_PriceBookMRQ",
        "",
        "Highlights_EarningsShare",
      ],
    },
    {
      title: "Income Statement",
      page: <IncomeStatement />,
      isHeading: ["yes", "no", "no", "no", "no"],
      headings: ["Income Statement", "Gross Profit Margin", "Operating Margin", "Net Profit", "NPAT < EBIT ?"],
      name: ["", "Highlights_ProfitMargin", "Highlights_OperatingMarginTTM", "Net_Income", "NBAT_Is_Less_Than_Ebit"],
    },
    {
      title: "Financial Health",
      page: <FinancialHealth />,
      isHeading: ["yes", "no", "yes", "no", "no", "no"],
      headings: ["Liquidity", "Current Ratio", "Solvency", "Debt / Equity", "Debt / Asset", "Net Debt to NTA"],
      name: ["", "Current_Ratio", "", "Debt_to_Equity", "Debt_To_Asset", "Net_Debt_To_NTA"],
    },
    {
      title: "Focus Ratio",
      page: <FocusRatio />,
      isHeading: ["yes", "no", "no"],
      headings: ["Focus Ratio", "Quality Income", "ORecTa%"],
      name: ["", "Earnings_Quality_Percentile", "Orecta_Percentage"],
    },
    {
      title: "Drivers Risks",
      page: <DriversRisks />,
      isHeading: ["yes", "no", "no"],
      headings: ["Focus Ratio", "Quality Income", "ORecTa%"],
      name: ["", "Earnings_Quality_Percentile", "Orecta_Percentage"],
    },
  ];

  const currentPage = stockItems.find((curr) => {
    return curr.title === current;
  });

  if (!currentPage) return null;

  return (
    <div className="stockDetailsTable">
      <div style={{ display: "flex", justifyContent: "space-between", padding: "18px" }}>
        <SoftTypography variant="h3">{theStockData.name}</SoftTypography>
        {!auth ||
        !auth.plan?.plan_features.available.includes("gem_ranking") ||
        !theStockData["GEM_Rank"] ||
        theStockData["GEM_Rank"] <= 0 ? (
          ""
        ) : (
          <p
            className="roboto"
            style={{
              display: "inline",
              marginTop: "auto",
              marginBottom: "auto",
              fontSize: "12px",
              color: "#A0AEC0",
            }}
          >
            {theStockData.GEM_Rank} out of 7276 stocks
          </p>
        )}
      </div>
      {currentPage.page}
      {infoPopup ? <StockInfoPopup toggleInfoPopup={toggleInfoPopup} popupAccessor={popupAccessor} /> : <div></div>}
      {/* {popup?
        <Popup>
                <CloseIcon className="close-btn icon" onClick={()=>{togglePopup(false)}} />
                <Payment forStocks={true}></Payment>
        </Popup>
        :
        <div></div>} */}
    </div>
  );
}

export default StockDetailsTable;
